import React, { useEffect, useState } from "react"
import Moment from "react-moment"
import { getFieldData } from "../../../Services/appService"
import { useDispatch, useSelector } from "react-redux";
import { getCurrentUser } from "../../store/auth";
import {
  getAppDocuments,
  getAppFormLibrary, getAppTasks, getCandidateApps,
  loadAppDocuments,
  loadAppFormLibrary, loadAppRuningTasks, loadCandidateApps
} from "../../store/candidate";
import AddEditNotes from "../../../Components/ApplicantProcessing/AddEditNotes";
import { setCurrentPageTitle, setCurrentRoute } from "../../store/layoutUI";
import UploadDocPopup from "../../../Components/UploadDocPopup";
import ViewFormModal from "../ViewFormModal";
import useDocDownload from "../../hooks/useDocDownload";
import { allowFormLibraryEdit, getFormLibraryEditStatus } from "../../store/forms";
import { getComponentUserStatus, UpdateComponentsUserStatus } from "../../store/tools";
import { OverlayTrigger, Popover } from "react-bootstrap";
import { getAlert, getConfirmAlert } from "../../../Services/appAlerts";
import { deleteDocument, getDocumentDeleteStatus } from "../../store/documents";

const ACH_STYLES = {
  card: {
    borderRadius: "22px",
    border: "1px solid rgba(226, 232, 240, 1)",
    background: "linear-gradient(180deg, #ffffff 0%, #fbfdff 100%)",
    boxShadow: "0 14px 34px rgba(15, 23, 42, 0.05)",
    overflow: "hidden"
  },
  cardHeader: {
    padding: "20px 22px 16px 22px",
    borderBottom: "1px solid rgba(226, 232, 240, 1)",
    background: "linear-gradient(180deg, #ffffff 0%, #f8fbff 100%)"
  },
  headerRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "16px",
    flexWrap: "wrap"
  },
  headerCopy: {
    minWidth: "240px",
    flex: "1 1 420px"
  },
  headerActions: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end"
  },
  title: {
    fontSize: "18px",
    fontWeight: 800,
    color: "#0f172a",
    lineHeight: 1.25,
    margin: 0
  },
  titleRow: {
    display: "flex",
    alignItems: "flex-start",
    gap: "12px"
  },
  titleIcon: {
    width: "34px",
    height: "34px",
    borderRadius: "10px",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    background: "#eff6ff",
    color: "#1d4ed8",
    fontSize: "15px",
    border: "1px solid rgba(191, 219, 254, 1)",
    flexShrink: 0
  },
  titleText: {
    display: "flex",
    flexDirection: "column",
    gap: "4px",
    minWidth: 0
  },
  subtitle: {
    fontSize: "13px",
    lineHeight: 1.5,
    color: "#64748b",
    margin: 0
  },
  cardBody: {
    padding: "18px 22px 22px 22px"
  },
  utilityRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "12px",
    flexWrap: "wrap",
    marginBottom: "14px"
  },
  refreshButton: {
    display: "inline-flex",
    alignItems: "center",
    gap: "8px",
    borderRadius: "999px",
    border: "1px solid rgba(226, 232, 240, 1)",
    background: "#ffffff",
    color: "#334155",
    padding: "7px 12px",
    fontSize: "12px",
    fontWeight: 700
  },
  tableWrap: {
    border: "1px solid rgba(226, 232, 240, 1)",
    borderRadius: "18px",
    overflow: "hidden",
    backgroundColor: "#ffffff"
  },
  table: {
    marginBottom: 0
  },
  tableHeadCell: {
    borderTop: "none",
    fontSize: "12px",
    fontWeight: 800,
    letterSpacing: "0.08em",
    textTransform: "uppercase",
    color: "#64748b",
    background: "#f8fafc",
    padding: "14px 16px"
  },
  cell: {
    verticalAlign: "top",
    padding: "22px 16px",
    borderTop: "1px solid rgba(226, 232, 240, 0.75)"
  },
  achText: {
    fontSize: "13px",
    lineHeight: 1.6,
    color: "#475569"
  },
  achLabel: {
    fontSize: "12px",
    fontWeight: 700,
    color: "#0f172a",
    marginRight: "6px"
  },
  primaryAction: {
    display: "inline-flex",
    alignItems: "center",
    gap: "8px",
    borderRadius: "999px",
    border: "1px solid rgba(191, 219, 254, 1)",
    background: "#eff6ff",
    color: "#1d4ed8",
    padding: "7px 12px",
    fontSize: "12px",
    fontWeight: 700
  },
  secondaryAction: {
    display: "inline-flex",
    alignItems: "center",
    gap: "8px",
    borderRadius: "999px",
    border: "1px solid rgba(226, 232, 240, 1)",
    background: "#ffffff",
    color: "#334155",
    padding: "7px 12px",
    fontSize: "12px",
    fontWeight: 700
  },
  textButton: {
    border: "none",
    background: "transparent",
    color: "#2563eb",
    padding: 0,
    fontSize: "12px",
    fontWeight: 700
  },
  dangerButton: {
    border: "none",
    background: "transparent",
    color: "#dc2626",
    padding: 0,
    fontSize: "12px",
    fontWeight: 700
  },
  mutedText: {
    fontSize: "12px",
    color: "#64748b",
    lineHeight: 1.55
  },
  statusPill: {
    display: "inline-flex",
    alignItems: "center",
    gap: "8px",
    padding: "6px 10px",
    borderRadius: "999px",
    fontSize: "12px",
    fontWeight: 700,
    border: "1px solid rgba(226, 232, 240, 1)",
    backgroundColor: "#f8fafc",
    color: "#475569"
  }
};

export default function AchInfo() {

  const route = [
    { name: "Contract Management", url: "" },
    { name: "Enrollment Steps", url: "" },
  ];

  const [appFormLibrary, setAppFormLibrary] = useState([]);
  const [sentDocs, setSentDocs] = useState([]);
  const [wfTask, setWfTask] = useState(null);
  const [workflow, setWorkflow] = useState(null);
  const [formType, setFormType] = useState("ACH Information");
  const [formShowHide, setFormShowHide] = useState(false);
  const [formObj, setFormObj] = useState(null);
  const [noteShowHide, setNoteShowHide] = useState(false);
  const [notesType, setNotesType] = useState("formEditReq");
  const [appTasklist, setAppTasklist] = useState([]);
  const [selectedDocType, setSelectedDocType] = useState("");
  const [docUploadShowHide, setDocUploadShowHide] = useState(false);
  const [reviewerTask, setReviewerTask] = useState(null);
  const [allowEdit, setAllowEdit] = useState(false);

  const candidateAppsSelector = useSelector(getCandidateApps);
  const appTasksSelector = useSelector(getAppTasks);
  const appFormLibrarySelector = useSelector(getAppFormLibrary);
  const appDocumentsSelector = useSelector(getAppDocuments);
  const formLibraryEditStatusSelector = useSelector(getFormLibraryEditStatus);
  const componentUserStatusSelector = useSelector(getComponentUserStatus);
  const documentDeleteStatusSelector = useSelector(getDocumentDeleteStatus);

  const [handleDownloadFile] = useDocDownload();

  const dispatch = useDispatch();
  const currentUser = getCurrentUser();

  useEffect(() => {
    dispatch(setCurrentPageTitle("STEP-3 : ACH Information"));
    dispatch(setCurrentRoute(route))
  }, [])

  useEffect(() => {
    let usrId = currentUser.id;
    if (currentUser.linkUser)
      usrId = currentUser.linkUser;
    if (candidateAppsSelector.length === 0 && currentUser?.id > 0) {
      dispatch(loadCandidateApps(usrId))
    }
  }, []);

  useEffect(() => {
    if (candidateAppsSelector.length > 0 && currentUser?.id > 0) {
      const mainWorkflow = candidateAppsSelector.filter(x => x.workflowType === 1);
      if (mainWorkflow.length > 0) {
        const wf = mainWorkflow[0];
        setWorkflow(wf);
        let usrId = currentUser.id;
        if (currentUser.linkUser)
          usrId = currentUser.linkUser;
        if (currentUser?.id > 0) {
          dispatch(loadAppFormLibrary(wf.oldWorkflowId, usrId));
          dispatch(loadAppRuningTasks(wf.oldWorkflowId, usrId));
          dispatch(loadAppDocuments(wf.oldWorkflowId, usrId));
        }

      }
    }
  }, [candidateAppsSelector]);

  useEffect(() => {
    if (appTasksSelector.length > 0) {
      const filterTasks = appTasksSelector.filter(x => x.taskType === 1 && x.wiid > 0);
      if (filterTasks.length > 0) {
        const reviewTasks = filterTasks.filter(x => x.registrationType === "WP");
        if (reviewTasks.length > 0) setReviewerTask(reviewTasks[reviewTasks.length - 1]);
        setAppTasklist(filterTasks);
        setWfTask(filterTasks[0]);
      }
    }
  }, [appTasksSelector]);

  useEffect(() => {
    if (appFormLibrarySelector.length > 0) {
      const frmLibrary = appFormLibrarySelector.filter(x => x.formType === formType);
      setAppFormLibrary(frmLibrary);

      if (frmLibrary.length > 0) {
        let frmItems = "";
        frmLibrary.map((x, key) => {
          if (key > 0) frmItems += ",";
          frmItems += x.id;
        });

        handleUpdateComponent(frmItems, frmLibrary[0].ciid);
      }
    }
  }, [appFormLibrarySelector]);

  useEffect(() => {
    if (appDocumentsSelector.length > 0) {
      const appDocs = appDocumentsSelector;
      let sentDocs = appDocs.filter(
        (x) =>
          x.type === "send" &&
          x.uploadType !== "Invoice" &&
          x.docType !== "internal" &&
          x.docType !== "Messaging"
      );
      setSentDocs(sentDocs);
    }
  }, [appDocumentsSelector])

  const getVoidCheck = (item) => {
    const achDocs = sentDocs.filter(
      (x) => x.docType === `ach_${item.id}`
    );
    if (achDocs.length === 0) {
      return <button
        className="btn btn-sm border-0"
        style={ACH_STYLES.primaryAction}
        onClick={() =>
          handleUploadDocModalShowHide(`ach_${item.id}`)
        }
      >
        <i className="fa fa-upload" aria-hidden="true"></i>
        Upload
      </button>
    }

    if (achDocs.length > 0) {
      return <>
        <button
          className="btn btn-sm border-0 mb-2"
          style={ACH_STYLES.primaryAction}
          onClick={() =>
            handleUploadDocModalShowHide(`ach_${item.id}`)
          }
        >
          <i className="fa fa-upload" aria-hidden="true"></i>
          Upload
        </button>
        {achDocs.map(doc =>
          <div key={doc.id} className="mb-2">
            <button
              className="btn btn-sm p-0"
              style={ACH_STYLES.textButton}
              title="Download Document"
              onClick={() => handleDownloadFile(doc)
              }
            >
              {doc.documentName.length > 15
                ? doc.documentName.substring(0, 15) + "..."
                : doc.documentName}
            </button>
            <button
              className="btn btn-sm p-1 pl-0 pr-2 ml-2"
              style={ACH_STYLES.dangerButton}
              title="Delete File"
              onClick={() => handleDeleteAchDoc(doc.id)}
            >
              <i
                className="fa fa-trash"
                aria-hidden="true"
              ></i>
            </button>
            <div>{getPopover(doc.notes)}</div>
          </div>
        )}
      </>
    }
  }

  const handleDeleteAchDoc = async (id) => {
    const result = await getConfirmAlert("Warning", "Are you sure you want to delete this Document?", "warning");
    if (result.isConfirmed) {
      dispatch(deleteDocument(id));
    }
  }

  useEffect(() => {
    if (documentDeleteStatusSelector) {
      getAlert("", "Deleted Successfully", "success");
      if (workflow?.oldWorkflowId > 0) {
        let usrId = currentUser.id;
        if (currentUser.linkUser)
          usrId = currentUser.linkUser;
        dispatch(loadAppFormLibrary(workflow.oldWorkflowId, usrId));
        dispatch(loadAppDocuments(workflow.oldWorkflowId, usrId));
      }
    }
  }, [documentDeleteStatusSelector])

  const handleUploadDocModalShowHide = (type) => {
    if (!reviewerTask) {
      getAlert("Warning", "No Reviewer Found. Please Complete Your Onboarding/Enrollment Form.", "warning");
      return;
    }
    const acno = getFieldData(wfTask?.stateData, "achinfo", "Account_No");
    const rno = getFieldData(wfTask?.stateData, "achinfo", "Routing");
    if (rno === "" || acno === "") {
      getAlert("Warning", "Please complete the ACH Information form before uploading Voided Check.", "warning");
      return;
    }

    if (type === "save" || type === "") {
      setDocUploadShowHide(false);
      setSelectedDocType("");
      let usrId = currentUser.id;
      if (currentUser.linkUser)
        usrId = currentUser.linkUser;
      if (workflow?.oldWorkflowId)
        dispatch(loadAppDocuments(workflow.oldWorkflowId, usrId));
    } else {
      setDocUploadShowHide(true);
      setSelectedDocType(type);
    }
  };

  const handleFormShowHide = (frm) => {
    if (frm === "save") {
      setFormShowHide(false);
      setFormObj("");
      let usrId = currentUser.id;
      if (currentUser.linkUser)
        usrId = currentUser.linkUser;
      if (workflow && currentUser?.id > 0) dispatch(loadAppRuningTasks(workflow.oldWorkflowId, usrId));
    } else {
      setFormShowHide(!formShowHide);
      setFormObj(frm);
      if (frm?.allowEdit === 1) setAllowEdit(true);
    }
  };

  const handleNotesComments = (type, obj) => {
    if (type === "save") {
      setFormObj(null);
      setNoteShowHide(false);
      let usrId = currentUser.id;
      if (currentUser.linkUser)
        usrId = currentUser.linkUser;
      if (workflow?.oldWorkflowId > 0)
        dispatch(loadAppFormLibrary(workflow.oldWorkflowId, usrId));
    } else {
      setFormObj(obj);
      setNoteShowHide(!noteShowHide);
    }
  };

  const handleFormUpdate = () => {
    setAllowEdit(false);
    if (formObj?.id > 0)
      dispatch(allowFormLibraryEdit(formObj.id, 0));
  }

  useEffect(() => {
    if (formLibraryEditStatusSelector) {
      let usrId = currentUser.id;
      if (currentUser.linkUser)
        usrId = currentUser.linkUser;
      if (workflow?.oldWorkflowId > 0)
        dispatch(loadAppFormLibrary(workflow.oldWorkflowId, usrId));
    }
  }, [formLibraryEditStatusSelector]);

  const handleUpdateComponent = (compItems, ciid) => {
    const comp = componentUserStatusSelector.filter(x => x.compId === 20);
    let updCompItems = "";
    if (comp.length > 0) {
      updCompItems = comp[0].compItems;
    }
    const compObj = {
      compName: "ACH",
      performerId: currentUser.id,
      compItems: compItems,
      ciid: ciid,
      wiid: 0,
      iiid: 0,
      compId: 20
    }
    if (compItems !== "" && compItems !== updCompItems) {
      dispatch(UpdateComponentsUserStatus(compObj));
    }
  }

  const handleDocumentLoad = () => {
    let usrId = currentUser.id;
    if (currentUser.linkUser)
      usrId = currentUser.linkUser;
    if (workflow?.oldWorkflowId > 0) {
      dispatch(loadAppFormLibrary(workflow.oldWorkflowId, usrId));
      dispatch(loadAppDocuments(workflow.oldWorkflowId, usrId));
    }
  }

  const getPopover = (notes) => {
    const popover = (
      <Popover id="popover-basic">
        <Popover.Title as="h4">Notes</Popover.Title>
        <Popover.Content>{notes}</Popover.Content>
      </Popover>
    );
    return (
      <OverlayTrigger trigger="click" placement="top" overlay={popover}>
        <button className="btn btn-sm p-0" style={ACH_STYLES.textButton}>View Notes</button>
      </OverlayTrigger>
    );
  };

  return <React.Fragment>

    <div className="mt-2 form-group">
      <style>{`
        .ach-info-table tbody tr:hover {
          background-color: #fbfdff;
        }
      `}</style>
      <div className="card shadow-none border-1" style={ACH_STYLES.card}>
        <div className="card-header border-1" style={ACH_STYLES.cardHeader}>
          <div style={ACH_STYLES.headerRow}>
            <div style={ACH_STYLES.headerCopy}>
              <div style={ACH_STYLES.titleRow}>
                <span style={ACH_STYLES.titleIcon}>
                  <i className="fa fa-university" aria-hidden="true"></i>
                </span>
                <div style={ACH_STYLES.titleText}>
                  <div style={ACH_STYLES.title}>
                    ACH Information
                  </div>
                  <p style={ACH_STYLES.subtitle}>
                    Complete the ACH form, review account details, and upload the voided check from one place.
                  </p>
                </div>
              </div>
            </div>
            <div style={ACH_STYLES.headerActions}>
              <button
                className="btn btn-sm"
                style={ACH_STYLES.refreshButton}
                onClick={handleDocumentLoad}
              >
                <i className="fa fa-refresh" aria-hidden="true"></i>
                Refresh
              </button>
            </div>
          </div>
        </div>
        <div className="card-body border-1" style={ACH_STYLES.cardBody}>
          <div className="table-responsive" style={ACH_STYLES.tableWrap}>
            <table className="table align-items-center table-hover mb-0 ach-info-table" style={ACH_STYLES.table}>
              <thead>
                <tr>
                  <th scope="col" style={ACH_STYLES.tableHeadCell}>ACH Information</th>
                  <th scope="col" style={ACH_STYLES.tableHeadCell}>Action</th>
                  <th scope="col" style={ACH_STYLES.tableHeadCell}>Voided Check</th>
                </tr>
              </thead>
              <tbody>
                {appFormLibrary.map((item, index) => {
                  const bankName = wfTask && getFieldData(wfTask.stateData, "achinfo", "Bank_Name");
                  const routingNumber = wfTask && getFieldData(wfTask.stateData, "achinfo", "Routing");
                  const accountNumber = wfTask && getFieldData(wfTask.stateData, "achinfo", "Account_No");
                  const { allowEdit, lastUpdate, editRemarks } = item;

                  return (
                    <tr key={item.id || index}>
                      <td style={ACH_STYLES.cell}>
                        <div style={ACH_STYLES.achText}><span style={ACH_STYLES.achLabel}>Bank Name:</span>{bankName || "-"}</div>
                        <div style={ACH_STYLES.achText}><span style={ACH_STYLES.achLabel}>Routing Number:</span>{routingNumber || "-"}</div>
                        <div style={ACH_STYLES.achText}><span style={ACH_STYLES.achLabel}>Account Number:</span>{accountNumber || "-"}</div>
                      </td>

                      <td className="text-wrap" style={ACH_STYLES.cell}>
                        <button
                          type="button"
                          className="btn btn-sm border-0"
                          style={allowEdit === 1 ? ACH_STYLES.primaryAction : ACH_STYLES.secondaryAction}
                          onClick={() => handleFormShowHide(item)}
                        >
                          <i className={`fa ${!lastUpdate ? "fa-exclamation-circle" : allowEdit === 1 ? "fa-pencil-square-o" : "fa-eye"}`} aria-hidden="true"></i>
                          {!lastUpdate ? <>
                            ACH Form <span className="text-danger">*</span>
                          </> : allowEdit === 1 ? "View / Edit" : "View"}
                        </button>

                        <div className="mt-2" style={ACH_STYLES.mutedText}>
                          <strong>Last Edited:</strong>{" "}
                          {lastUpdate ? (
                            <Moment format="MMM Do YYYY, h:mm a">
                              {lastUpdate}
                            </Moment>
                          ) : (
                            <span>-</span>
                          )}
                        </div>

                        {allowEdit === 0 && (
                          <div className="mt-1">
                            <button
                              type="button"
                              className="btn btn-sm p-0"
                              style={ACH_STYLES.textButton}
                              onClick={() => handleNotesComments("", item)}
                            >
                              Request Edit
                            </button>
                          </div>
                        )}

                        {allowEdit === 2 && (
                          <div className="mt-1" style={ACH_STYLES.mutedText}>
                            <span style={ACH_STYLES.statusPill}>Request Sent</span>
                            {editRemarks && (
                              <div className="mt-1">{editRemarks}</div>
                            )}
                          </div>
                        )}
                      </td>

                      <td style={ACH_STYLES.cell}>{getVoidCheck(item)}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>

          </div>
        </div>
      </div>
    </div>
    {docUploadShowHide &&
      <UploadDocPopup
        uploadDocShowHide={docUploadShowHide}
        handleUploadDocModalShowHide={handleUploadDocModalShowHide}
        runningApplication={reviewerTask ? [reviewerTask] : []}
        selectedDocType={selectedDocType}
        contactDoc="Your Voided Check has been successfully attached to workbench portal"
      ></UploadDocPopup>}

    {formShowHide && <ViewFormModal
      viewFormShowHide={formShowHide}
      handleViewForm={handleFormShowHide}
      workflowTask={wfTask}
      selectedForm={formObj}
      handleFormUpdate={handleFormUpdate}
      allowEdit={allowEdit}
      formName="ACH Information"
    ></ViewFormModal>}

    {/* {formShowHide && <ViewForm
      formShowHide={formShowHide}
      handleFormShowHide={handleFormShowHide}
      workflowTask={wfTask}
      selectedForm={formObj}
    ></ViewForm>} */}

    {noteShowHide && <AddEditNotes
      noteShowHide={noteShowHide}
      handleNoteShowHide={handleNotesComments}
      notesType={notesType}
      candidateObj={currentUser}
      selectedObj={formObj}
    ></AddEditNotes>}
  </React.Fragment>
}
